import { capitalize } from '@tunasong/models'
import type { ChangeEvent, FC, SelectHTMLAttributes } from 'react'
import { FormControl, Select } from '../primitives/index.js'

export interface EnumSelectProps extends Omit<SelectHTMLAttributes<HTMLSelectElement>, 'onChange'> {
  label?: string
  values?: string[] | Record<string, string>
  fullWidth?: boolean
  onChange?: (event: ChangeEvent<HTMLSelectElement>) => void
}

export const EnumSelect: FC<EnumSelectProps> = props => {
  const { values = [], label, fullWidth = true, onChange, ...restProps } = props

  const enumValues = Array.isArray(values) ? values : Object.values(values)
  const enumKeys = Array.isArray(values) ? values.map(v => capitalize(v)) : Object.keys(values)

  return (
    <FormControl fullWidth={fullWidth} style={{ marginTop: 8 }}>
      <Select
        {...restProps}
        label={label}
        onChange={onChange}
      >
        {enumValues.map((val, idx) => (
          <option key={idx} value={val}>
            {enumKeys[idx]}
          </option>
        ))}
      </Select>
    </FormControl>
  )
}
